// Centralized data-testid constants for the campaign site.
export const TID = {
  // Nav
  navBrand: "nav-brand",
  navPetition: "nav-cta-petition",
  navJoin: "nav-cta-join",
  navMobileToggle: "nav-mobile-toggle",

  // Hero
  heroHeadline: "hero-headline",
  heroSubheadline: "hero-subheadline",
  heroPetitionBtn: "hero-cta-petition",
  heroJoinBtn: "hero-cta-join",
  heroPortrait: "hero-portrait",

  // Platform
  platformSection: "platform-section",
  pillarSmartGrowth: "pillar-smart-growth",
  pillarReliability: "pillar-reliability",
  pillarDrone: "pillar-drone",

  // Contact (formerly the Petition section)
  petitionSection: "petition-section",

  // About
  aboutSection: "about-section",
  aboutImage: "about-image",

  // Community
  communitySection: "community-section",

  // Footer
  footerSection: "footer-section",
  newsletterEmail: "newsletter-email",
  newsletterZip: "newsletter-zip",
  newsletterSubmit: "newsletter-submit",
  newsletterSuccess: "newsletter-success",
  socialFacebook: "social-facebook",
  socialInstagram: "social-instagram",
  socialLinkedin: "social-linkedin",
  footerDisclosure: "footer-disclosure",
};
